import { createAction } from "@reduxjs/toolkit";

export const setSaveTo = createAction<string>("SET_SAVE_TO");
export const setFileTemplate = createAction<string>("SET_FILE_TEMPLATE");
